export default __webpack_public_path__ + "static/media/badge-first.21d9af7c.svg";